// extracted by mini-css-extract-plugin
module.exports = {"otherOfferCard":"VitrinsOffersCards_otherOfferCard__P8VfQ"};